export const GENERIC_REDIRECT_WHITELIST_PATHS = [
  '/get-started/id-selfie-upload',
  '/sign-redo',
  '/manual-lender',
  '/my-claims',
];
